
define([
    './login',
    './notice',
    './signage',
    './view',
], function () {
});